import Vuex from 'vuex'
import generalModule from './general'
import user from './user'
import setPersistState from './localStorePersist';

const store = new Vuex.Store({
    modules: {
        generalModule,
        user
    }
})

setPersistState(store, 'user', user);

export default store;
